var map = {
	"./1893/title_no.svg": "9bda",
	"./1925/title_no.svg": "07f3",
	"./1949/title_no.svg": "1373",
	"./1951/title_no.svg": "c943",
	"./1956/title_no.svg": "7796",
	"./1960/title_no.svg": "8eee",
	"./1982/title_no.svg": "b841",
	"./1993/title_no.svg": "fdd0",
	"./2016/title_no.svg": "8164"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ecd1";